import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65421dec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-7 gap-lg-10" }
const _hoisted_2 = { class: "row gy-5 g-xl-10" }
const _hoisted_3 = { class: "col-xl-8 mb-5 mb-xl-10" }
const _hoisted_4 = { class: "row g-5 g-xl-10 h-xxl-50 mb-0 mb-xl-10" }
const _hoisted_5 = { class: "col-xxl-12" }
const _hoisted_6 = { class: "card card-flush" }
const _hoisted_7 = { class: "card-header pt-5" }
const _hoisted_8 = { class: "card-title align-items-start flex-column" }
const _hoisted_9 = { class: "card-toolbar" }
const _hoisted_10 = {
  class: "nav",
  role: "tablist"
}
const _hoisted_11 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_12 = {
  class: "nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 me-1",
  "data-bs-toggle": "tab",
  href: "#kt_ordered_items_1_tab",
  "aria-selected": "false",
  role: "tab"
}
const _hoisted_13 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_14 = {
  class: "nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 me-1 active",
  "data-bs-toggle": "tab",
  href: "#kt_ordered_items_2_tab",
  "aria-selected": "true",
  role: "tab",
  tabindex: "-1"
}
const _hoisted_15 = { class: "card-body pb-0" }
const _hoisted_16 = { class: "tab-content" }
const _hoisted_17 = {
  class: "tab-pane blockui",
  id: "kt_ordered_items_1_tab",
  role: "tabpanel"
}
const _hoisted_18 = { class: "table-responsive" }
const _hoisted_19 = { class: "table align-middle table-row-dashed fs-6 gy-5 mb-0" }
const _hoisted_20 = { class: "text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_21 = { class: "min-w-175px" }
const _hoisted_22 = { class: "min-w-100px text-start" }
const _hoisted_23 = { class: "min-w-70px text-end" }
const _hoisted_24 = { class: "min-w-100px text-end" }
const _hoisted_25 = {
  key: 0,
  class: "min-w-70px text-end"
}
const _hoisted_26 = { class: "min-w-100px text-end" }
const _hoisted_27 = { class: "fw-bold text-gray-800" }
const _hoisted_28 = { class: "text-start" }
const _hoisted_29 = { class: "text-end" }
const _hoisted_30 = { class: "d-flex flex-column gap-1 text-nowrap text-gray-400" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { class: "text-end" }
const _hoisted_36 = {
  key: 0,
  class: "text-end"
}
const _hoisted_37 = { class: "text-end" }
const _hoisted_38 = ["colspan"]
const _hoisted_39 = { class: "text-end" }
const _hoisted_40 = ["colspan"]
const _hoisted_41 = { class: "text-end" }
const _hoisted_42 = ["colspan"]
const _hoisted_43 = { class: "text-end" }
const _hoisted_44 = ["colspan"]
const _hoisted_45 = { class: "d-flex flex-column gap-2" }
const _hoisted_46 = { class: "fs-3" }
const _hoisted_47 = { class: "text-dark text-end text-nowrap" }
const _hoisted_48 = { class: "d-flex flex-column gap-2" }
const _hoisted_49 = { class: "fs-3 fw-bolder" }
const _hoisted_50 = {
  class: "tab-pane blockui active show",
  id: "kt_ordered_items_2_tab",
  role: "tabpanel"
}
const _hoisted_51 = { class: "table-responsive" }
const _hoisted_52 = { class: "table align-middle table-row-dashed fs-6 gy-5 mb-0" }
const _hoisted_53 = { class: "text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_54 = { class: "min-w-175px text-uppercase" }
const _hoisted_55 = { class: "min-w-100px text-start text-uppercase" }
const _hoisted_56 = { class: "text-end text-uppercase" }
const _hoisted_57 = { class: "text-end text-uppercase" }
const _hoisted_58 = { class: "text-uppercase" }
const _hoisted_59 = { class: "svg-icon svg-icon-2" }
const _hoisted_60 = { class: "text-end text-uppercase" }
const _hoisted_61 = { class: "text-uppercase" }
const _hoisted_62 = { class: "svg-icon svg-icon-2" }
const _hoisted_63 = { class: "text-end text-uppercase" }
const _hoisted_64 = { class: "text-uppercase" }
const _hoisted_65 = { class: "svg-icon svg-icon-2" }
const _hoisted_66 = { class: "text-end text-uppercase" }
const _hoisted_67 = { class: "text-uppercase" }
const _hoisted_68 = { class: "svg-icon svg-icon-2" }
const _hoisted_69 = { class: "fw-bold text-gray-800" }
const _hoisted_70 = { class: "text-start" }
const _hoisted_71 = { class: "text-end" }
const _hoisted_72 = { class: "text-end" }
const _hoisted_73 = { class: "text-end" }
const _hoisted_74 = { class: "text-end" }
const _hoisted_75 = { class: "text-end" }
const _hoisted_76 = { class: "col-xxl-12" }
const _hoisted_77 = { class: "card" }
const _hoisted_78 = { class: "card-header pt-5" }
const _hoisted_79 = { class: "card-title align-items-start flex-column" }
const _hoisted_80 = { class: "card-body" }
const _hoisted_81 = { class: "timeline" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-40px" }, null, -1))
const _hoisted_83 = { class: "timeline-icon symbol symbol-circle symbol-40px me-4" }
const _hoisted_84 = { class: "symbol-label bg-light" }
const _hoisted_85 = { class: "pe-3 ps-3" }
const _hoisted_86 = { class: "d-flex align-items-center fs-5 gap-2" }
const _hoisted_87 = { key: 0 }
const _hoisted_88 = ["data-bs-target", "aria-controls"]
const _hoisted_89 = { class: "toggle-off" }
const _hoisted_90 = { class: "toggle-on" }
const _hoisted_91 = { class: "fs-5 fw-bold text-uppercase mb-1" }
const _hoisted_92 = {
  key: 0,
  class: "d-flex flex-column fs-6"
}
const _hoisted_93 = { class: "fs-7 d-flex align-items-center" }
const _hoisted_94 = ["innerHTML"]
const _hoisted_95 = {
  key: 1,
  class: "d-flex flex-column fs-6"
}
const _hoisted_96 = { class: "fs-7 d-flex align-items-center" }
const _hoisted_97 = ["innerHTML"]
const _hoisted_98 = {
  key: 2,
  class: "d-flex flex-column fs-6"
}
const _hoisted_99 = { class: "fs-7 d-flex align-items-center" }
const _hoisted_100 = ["innerHTML"]
const _hoisted_101 = {
  key: 3,
  class: "d-flex flex-column fs-6"
}
const _hoisted_102 = { class: "fs-7 d-flex align-items-center" }
const _hoisted_103 = ["innerHTML"]
const _hoisted_104 = {
  key: 4,
  class: "d-flex flex-column fs-6"
}
const _hoisted_105 = { class: "fs-7 d-flex align-items-center" }
const _hoisted_106 = ["innerHTML"]
const _hoisted_107 = {
  key: 1,
  class: "d-flex align-items-center fs-6"
}
const _hoisted_108 = { class: "fs-7 text-muted" }
const _hoisted_109 = ["id"]
const _hoisted_110 = { class: "overflow-auto pb-5" }
const _hoisted_111 = { class: "d-flex flex-column gap-4" }
const _hoisted_112 = { class: "ps-3" }
const _hoisted_113 = { class: "fs-7 d-flex align-items-center" }
const _hoisted_114 = ["innerHTML"]
const _hoisted_115 = ["innerHTML"]
const _hoisted_116 = ["innerHTML"]
const _hoisted_117 = ["innerHTML"]
const _hoisted_118 = ["innerHTML"]
const _hoisted_119 = ["innerHTML"]
const _hoisted_120 = {
  key: 0,
  class: "d-flex align-items-center border border-dashed border-gray-300 rounded px-3 py-3 my-2"
}
const _hoisted_121 = { class: "flex-fill d-flex align-items-sm-center border-end pe-8" }
const _hoisted_122 = { class: "symbol symbol-45px me-4" }
const _hoisted_123 = { class: "symbol-label" }
const _hoisted_124 = { class: "d-flex align-items-center flex-row-fluid flex-wrap" }
const _hoisted_125 = { class: "flex-grow-1 me-2" }
const _hoisted_126 = { class: "d-flex align-items-center" }
const _hoisted_127 = { class: "text-gray-400 fw-semibold" }
const _hoisted_128 = { class: "text-gray-800 fw-bold d-block fs-4" }
const _hoisted_129 = { class: "flex-fill timeline template-one ps-8" }
const _hoisted_130 = { class: "timeline-item align-items-center mb-4" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-20px mt-2 mb-n8 bottom-0" }, null, -1))
const _hoisted_132 = { class: "timeline-icon align-self-start" }
const _hoisted_133 = { class: "svg-icon svg-icon-2 svg-icon-danger" }
const _hoisted_134 = { class: "timeline-content m-0" }
const _hoisted_135 = { class: "break-all" }
const _hoisted_136 = { class: "fs-6 fw-bolder" }
const _hoisted_137 = { class: "fw-semibold ms-2" }
const _hoisted_138 = { class: "timeline-item align-items-center mb-4" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-20px mt-2 mb-n8" }, null, -1))
const _hoisted_140 = { class: "timeline-icon align-self-start" }
const _hoisted_141 = { class: "svg-icon svg-icon-2 svg-icon-info" }
const _hoisted_142 = { class: "timeline-content m-0" }
const _hoisted_143 = { class: "break-all" }
const _hoisted_144 = { class: "fs-6 fw-bolder text-hover-primary" }
const _hoisted_145 = { class: "fw-semibold ms-2" }
const _hoisted_146 = {
  key: 0,
  class: "d-flex align-items-center gap-4"
}
const _hoisted_147 = { class: "d-flex align-items-center" }
const _hoisted_148 = { class: "symbol symbol-50px w-50px me-4" }
const _hoisted_149 = { class: "symbol-label bg-light" }
const _hoisted_150 = { class: "symbol-badge badge badge-circle bg-primary top-100 start-100" }
const _hoisted_151 = { class: "flex-fill d-flex flex-column justify-content-between flex-nowrap leading-none h-50px" }
const _hoisted_152 = { class: "fs-5 text-gray-800 fw-bold mw-175px text-line-clamp-1 break-all" }
const _hoisted_153 = { class: "text-gray-400 fs-7" }
const _hoisted_154 = ["innerHTML"]
const _hoisted_155 = { class: "col-xl-4 mb-xl-10 d-flex flex-column gap-5 gap-xl-10" }
const _hoisted_156 = { class: "card-header pt-7" }
const _hoisted_157 = { class: "card-title align-items-start flex-column flex-fill" }
const _hoisted_158 = { class: "text-gray-400 mt-1 fw-semibold fs-6" }
const _hoisted_159 = {
  key: 0,
  class: "text-gray-400 mt-1 fw-semibold fs-6"
}
const _hoisted_160 = {
  key: 0,
  class: "card-toolbar"
}
const _hoisted_161 = ["onClick"]
const _hoisted_162 = { class: "svg-icon svg-icon-2" }
const _hoisted_163 = { class: "card-body" }
const _hoisted_164 = { class: "d-flex align-items-sm-center mb-5" }
const _hoisted_165 = { class: "symbol symbol-45px me-4" }
const _hoisted_166 = { class: "symbol-label" }
const _hoisted_167 = { class: "d-flex align-items-center flex-row-fluid flex-wrap" }
const _hoisted_168 = { class: "flex-grow-1 me-2" }
const _hoisted_169 = { class: "text-gray-400 fs-6 fw-semibold" }
const _hoisted_170 = { class: "text-gray-800 fw-bold d-block fs-4" }
const _hoisted_171 = { key: 0 }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mt-6" }, null, -1))
const _hoisted_173 = { class: "overflow-auto d-flex gap-4 py-6" }
const _hoisted_174 = { class: "symbol-label bg-lighten" }
const _hoisted_175 = { class: "symbol-badge badge badge-circle bg-primary top-100 start-100" }
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-6" }, null, -1))
const _hoisted_177 = { class: "m-0" }
const _hoisted_178 = { class: "timeline template-one" }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-20px mt-2 mb-n8" }, null, -1))
const _hoisted_180 = { class: "timeline-icon align-self-start" }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-line w-20px mt-2 mb-n8" }, null, -1))
const _hoisted_182 = { class: "timeline-icon align-self-start" }
const _hoisted_183 = { class: "fs-6 text-gray-900 fw-bolder d-block" }
const _hoisted_184 = {
  key: 0,
  class: "d-block fw-semibold text-gray-400"
}
const _hoisted_185 = { class: "fw-semibold text-gray-400" }
const _hoisted_186 = ["innerHTML"]
const _hoisted_187 = {
  key: 0,
  class: "separator separator-dashed my-6"
}
const _hoisted_188 = { class: "timeline-label" }
const _hoisted_189 = { class: "timeline-label fw-bold text-gray-800 fs-6" }
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-badge" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless fs-1" })
], -1))
const _hoisted_191 = { class: "timeline-content d-flex flex-column ps-3" }
const _hoisted_192 = { class: "fw-bold text-gray-800" }
const _hoisted_193 = { class: "fs-7 d-flex align-items-center" }
const _hoisted_194 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_FsLightbox = _resolveComponent("FsLightbox")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrderOverview.orderItems")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("ul", _hoisted_10, [
                      _createElementVNode("li", _hoisted_11, [
                        _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsDetails")), 1)
                      ]),
                      _createElementVNode("li", _hoisted_13, [
                        _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsProgress")), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("table", _hoisted_19, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", _hoisted_20, [
                              _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.t("order.product")), 1),
                              _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.t("order.sku")), 1),
                              _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.t("order.qty")), 1),
                              _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.t("order.unitPrice")), 1),
                              (!_ctx.isAuditView)
                                ? (_openBlock(), _createElementBlock("th", _hoisted_25, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsDiscount")), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsTotal")), 1)
                            ])
                          ]),
                          _createElementVNode("tbody", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salesOrderOverviewData.ordered_items, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", null, [
                                  _createVNode(_component_product_info, {
                                    brand_id: item.brand,
                                    gallery: [
                                  {
                                    id: 0,
                                    origin_url: item.image,
                                  },
                                ],
                                    name: item.sku_name_cn,
                                    name_en: item.sku_name_en
                                  }, null, 8, ["brand_id", "gallery", "name", "name_en"])
                                ]),
                                _createElementVNode("td", _hoisted_28, [
                                  _createVNode(_component_sku_info, {
                                    brand_article_no: item.brand_article_number,
                                    size: item.size,
                                    color: item.color
                                  }, null, 8, ["brand_article_no", "size", "color"])
                                ]),
                                _createElementVNode("td", _hoisted_29, [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("span", {
                                      innerHTML: 
                                    _ctx.t('salesOrderOverview.qtyOrdered', [
                                      item.qty_ordered,
                                    ])
                                  
                                    }, null, 8, _hoisted_31),
                                    (item.paid_qty > 0 && !_ctx.isAuditView)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          innerHTML: 
                                    _ctx.t('salesOrderOverview.qtyPaid', [
                                      item.paid_qty,
                                    ])
                                  
                                        }, null, 8, _hoisted_32))
                                      : _createCommentVNode("", true),
                                    (item.qty_refunded > 0 && !_ctx.isAuditView)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          innerHTML: 
                                    _ctx.t('salesOrderOverview.qtyRefunded', [
                                      item.qty_refunded,
                                    ])
                                  
                                        }, null, 8, _hoisted_33))
                                      : _createCommentVNode("", true),
                                    (item.qty_canceled > 0 && !_ctx.isAuditView)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 2,
                                          innerHTML: 
                                    _ctx.t('salesOrderOverview.qtyCanceled', [
                                      item.qty_canceled,
                                    ])
                                  
                                        }, null, 8, _hoisted_34))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.salesOrderOverviewData.base_currency_code ==
                                "￥"
                                  ? _ctx.$currency.currency(
                                      item.base_unit_sales_order_price,
                                      2,
                                      ".",
                                      "",
                                      _ctx.salesOrderOverviewData.base_currency_code +
                                        " "
                                    )
                                  : _ctx.$currency.currency(
                                      item.base_unit_sales_order_price,
                                      2,
                                      ",",
                                      ".",
                                      _ctx.salesOrderOverviewData.base_currency_code +
                                        " "
                                    )), 1),
                                (!_ctx.isAuditView)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_36, _toDisplayString(parseFloat(item.base_discount_percent) === 0
                                  ? _ctx.$currency.currency(
                                      (1 -
                                        item.base_selling_price /
                                          item.base_original_price) *
                                        100,
                                      2,
                                      ",",
                                      "",
                                      ""
                                    )
                                  : _ctx.$currency.currency(
                                      item.base_discount_percent,
                                      2,
                                      ",",
                                      "",
                                      ""
                                    )) + "% ", 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("td", _hoisted_37, _toDisplayString(_ctx.salesOrderOverviewData.base_currency_code ==
                                "￥"
                                  ? _ctx.$currency.currency(
                                      item.base_row_total_incl_tax,
                                      2,
                                      ".",
                                      "",
                                      _ctx.salesOrderOverviewData.base_currency_code +
                                        " "
                                    )
                                  : _ctx.$currency.currency(
                                      item.base_row_total_incl_tax,
                                      2,
                                      ",",
                                      ".",
                                      _ctx.salesOrderOverviewData.base_currency_code +
                                        " "
                                    )), 1)
                              ]))
                            }), 128)),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", {
                                colspan: _ctx.isAuditView ? 4 : 5,
                                class: "text-end"
                              }, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsSubtotal")), 9, _hoisted_38),
                              _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.$currency.currency(
                                  _ctx.salesOrderOverviewData.order_totals
                                    .base_sub_total,
                                  2,
                                  ",",
                                  ".",
                                  _ctx.salesOrderOverviewData.base_currency_code +
                                    " "
                                )), 1)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getVatArr, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", {
                                  colspan: _ctx.isAuditView ? 4 : 5,
                                  class: "text-end"
                                }, _toDisplayString(_ctx.salesOrderOverviewData.shipping_address
                                  .recipient_country_id == "DE"
                                  ? _ctx.t(
                                      "salesOrderOverview.orderItemsVatHasParams",
                                      [
                                        _ctx.$currency.currency(
                                          item.tax_percent,
                                          2,
                                          ".",
                                          "",
                                          ""
                                        ),
                                      ]
                                    )
                                  : _ctx.t(
                                      "salesOrderOverview.orderItemsTaxHasParams",
                                      [
                                        _ctx.$currency.currency(
                                          item.tax_percent,
                                          2,
                                          ".",
                                          "",
                                          ""
                                        ),
                                      ]
                                    )), 9, _hoisted_40),
                                _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.$currency.currency(
                                  item.base_tax_amount,
                                  2,
                                  ",",
                                  ".",
                                  _ctx.salesOrderOverviewData.base_currency_code +
                                    " "
                                )), 1)
                              ]))
                            }), 128)),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", {
                                colspan: _ctx.isAuditView ? 4 : 5,
                                class: "text-end"
                              }, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsShippingFee")), 9, _hoisted_42),
                              _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.$currency.currency(
                                  _ctx.salesOrderOverviewData.order_totals
                                    .base_shipping_amount,
                                  2,
                                  ",",
                                  ".",
                                  _ctx.salesOrderOverviewData.base_currency_code +
                                    " "
                                )), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", {
                                colspan: _ctx.isAuditView ? 4 : 5,
                                class: "text-dark text-end"
                              }, [
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsGrandTotal")), 1),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.t("salesOrderOverview.totalPaid")), 1),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.t("salesOrderOverview.totalRefunded")), 1),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.t("salesOrderOverview.totalDue")), 1)
                                ])
                              ], 8, _hoisted_44),
                              _createElementVNode("td", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$currency.currency(
                                    _ctx.salesOrderOverviewData.order_totals
                                      .base_grand_total_gross,
                                    2,
                                    ",",
                                    ".",
                                    _ctx.salesOrderOverviewData.base_currency_code +
                                      " "
                                  )), 1),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$currency.currency(
                                    _ctx.salesOrderOverviewData.order_totals
                                      .base_total_paid,
                                    2,
                                    ",",
                                    ".",
                                    _ctx.salesOrderOverviewData.base_currency_code +
                                      " "
                                  )), 1),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$currency.currency(
                                    _ctx.salesOrderOverviewData.order_totals
                                      .base_total_refunded
                                      ? _ctx.salesOrderOverviewData.order_totals
                                          .base_total_refunded
                                      : "0",
                                    2,
                                    ",",
                                    ".",
                                    _ctx.salesOrderOverviewData.base_currency_code +
                                      " "
                                  )), 1),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$currency.currency(
                                    _ctx.salesOrderOverviewData.order_totals
                                      .base_total_due,
                                    2,
                                    ",",
                                    ".",
                                    _ctx.salesOrderOverviewData.base_currency_code +
                                      " "
                                  )), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("table", _hoisted_52, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", _hoisted_53, [
                              _createElementVNode("th", _hoisted_54, _toDisplayString(_ctx.t("order.product")), 1),
                              _createElementVNode("th", _hoisted_55, _toDisplayString(_ctx.t("order.sku")), 1),
                              _createElementVNode("th", _hoisted_56, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsQty")), 1),
                              _createElementVNode("th", _hoisted_57, [
                                _createVNode(_component_el_popover, {
                                  placement: "top",
                                  width: "auto",
                                  trigger: "hover"
                                }, {
                                  reference: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_59, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm005.svg" })
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsConf")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("th", _hoisted_60, [
                                _createVNode(_component_el_popover, {
                                  placement: "top",
                                  width: "auto",
                                  trigger: "hover"
                                }, {
                                  reference: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_62, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm009.svg" })
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsStock")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("th", _hoisted_63, [
                                _createVNode(_component_el_popover, {
                                  placement: "top",
                                  width: "auto",
                                  trigger: "hover"
                                }, {
                                  reference: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_65, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm010.svg" })
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsChk")), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("th", _hoisted_66, [
                                _createVNode(_component_el_popover, {
                                  placement: "top",
                                  width: "auto",
                                  trigger: "hover"
                                }, {
                                  reference: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_68, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm006.svg" })
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.t("salesOrderOverview.orderItemsShipped")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _createElementVNode("tbody", _hoisted_69, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.salesOrderOverviewData.ordered_items, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", null, [
                                  _createVNode(_component_product_info, {
                                    brand_id: item.brand,
                                    gallery: [
                                  {
                                    id: 0,
                                    origin_url: item.image,
                                  },
                                ],
                                    name: item.sku_name_cn,
                                    name_en: item.sku_name_en
                                  }, null, 8, ["brand_id", "gallery", "name", "name_en"])
                                ]),
                                _createElementVNode("td", _hoisted_70, [
                                  _createVNode(_component_sku_info, {
                                    brand_article_no: item.brand_article_number,
                                    size: item.size,
                                    color: item.color
                                  }, null, 8, ["brand_article_no", "size", "color"])
                                ]),
                                _createElementVNode("td", _hoisted_71, _toDisplayString(item.qty_ordered), 1),
                                _createElementVNode("td", _hoisted_72, _toDisplayString(item.confirmed_qty), 1),
                                _createElementVNode("td", _hoisted_73, _toDisplayString(item.stock_in_qty), 1),
                                _createElementVNode("td", _hoisted_74, _toDisplayString(item.passed_qty), 1),
                                _createElementVNode("td", _hoisted_75, _toDisplayString(parseInt(item.shipped_qty)), 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.loading]
              ])
            ]),
            _createElementVNode("div", _hoisted_76, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrderOverview.orderProgression")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderAssginOrderProgressionData, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "timeline-item",
                        key: index
                      }, [
                        _hoisted_82,
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", _hoisted_84, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["svg-icon svg-icon-1", {
                            'svg-icon-success': item.crossed === 1,
                            'svg-icon-primary':
                              _ctx.getOrderProgressionCurrentStatus(index),
                          }])
                            }, [
                              _createVNode(_component_inline_svg_icon, {
                                src: _ctx.getOrderTrackingOrderProgressionMap(item.key)
                              }, null, 8, ["src"])
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["timeline-content mb-10 mt-n1", {
                        'opacity-50':
                          !_ctx.getOrderProgressionCurrentStatus(index) &&
                          item.crossed === 0,
                      }])
                        }, [
                          _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("div", _hoisted_86, [
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.date, (row, rowIndex) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    class: "timeline-date-time",
                                    key: rowIndex
                                  }, [
                                    (rowIndex != 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_87, " - "))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.customFormatDateTime(row)), 1)
                                  ]))
                                }), 128))
                              ]),
                              (
                              (item.sku_list.length > 0 ||
                                item.items.length > 0) &&
                              !_ctx.isAuditView
                            )
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "cursor-pointer collapsible collapsed toggle fs-6 text-primary",
                                    role: "button",
                                    "data-bs-toggle": "collapse",
                                    "data-bs-target": 
                              '#' + _ctx.getOrderProgressionTarget(item.key, index)
                            ,
                                    "aria-expanded": "false",
                                    "aria-controls": 
                              _ctx.getOrderProgressionTarget(item.key, index)
                            
                                  }, [
                                    _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.t(
                                "salesOrderOverview.orderProgressionViewDetails"
                              )), 1),
                                    _createElementVNode("span", _hoisted_90, _toDisplayString(_ctx.t(
                                "salesOrderOverview.orderProgressionCloseDetails"
                              )), 1)
                                  ], 8, _hoisted_88))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.getOrderTrackingOrderProgressionKeyMap(item.key, _ctx.t)), 1),
                            (item.completion.length > 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (
                              item.key ===
                              _ctx.OrderTrackingOrderProgressionKey.OrderAssign
                            )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                                        _createElementVNode("div", _hoisted_93, [
                                          _createElementVNode("div", {
                                            class: "text-muted",
                                            innerHTML: 
                                    _ctx.t(
                                      'salesOrderOverview.orderProgressionAssignedProgress',
                                      item.completion
                                    )
                                  
                                          }, null, 8, _hoisted_94)
                                        ])
                                      ]))
                                    : (
                              item.key ===
                              _ctx.OrderTrackingOrderProgressionKey.OrderApproved
                            )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                          _createElementVNode("div", _hoisted_96, [
                                            _createElementVNode("div", {
                                              class: "text-muted",
                                              innerHTML: 
                                    _ctx.t(
                                      'salesOrderOverview.orderProgressionApprovedTotal',
                                      item.completion
                                    )
                                  
                                            }, null, 8, _hoisted_97)
                                          ])
                                        ]))
                                      : (
                              item.key ===
                              _ctx.OrderTrackingOrderProgressionKey.OrderShipped
                            )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                            _createElementVNode("div", _hoisted_99, [
                                              _createElementVNode("div", {
                                                class: "text-muted",
                                                innerHTML: 
                                    _ctx.t(
                                      'salesOrderOverview.orderProgressionShippedTotal',
                                      item.completion
                                    )
                                  
                                              }, null, 8, _hoisted_100)
                                            ])
                                          ]))
                                        : (
                              item.key ===
                              _ctx.OrderTrackingOrderProgressionKey.ArticleReview
                            )
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                              _createElementVNode("div", _hoisted_102, [
                                                _createElementVNode("div", {
                                                  class: "text-muted",
                                                  innerHTML: 
                                    _ctx.t(
                                      'salesOrderOverview.orderProgressionArticleReviewTotal',
                                      item.completion
                                    )
                                  
                                                }, null, 8, _hoisted_103)
                                              ])
                                            ]))
                                          : (
                              item.key ===
                              _ctx.OrderTrackingOrderProgressionKey.ArticleShipped
                            )
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                                _createElementVNode("div", _hoisted_105, [
                                                  _createElementVNode("div", {
                                                    class: "text-muted",
                                                    innerHTML: 
                                    _ctx.t(
                                      'salesOrderOverview.orderProgressionArticleShippedTotal',
                                      item.completion
                                    )
                                  
                                                  }, null, 8, _hoisted_106)
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true),
                            (item.description)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                  _createElementVNode("div", _hoisted_108, _toDisplayString(item.description), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            id: _ctx.getOrderProgressionTarget(item.key, index),
                            class: "collapse"
                          }, [
                            _createElementVNode("div", _hoisted_110, [
                              _createElementVNode("div", _hoisted_111, [
                                _createElementVNode("div", _hoisted_112, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (row, rowIndex) => {
                                    return (_openBlock(), _createElementBlock("div", { key: rowIndex }, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_113, [
                                          (
                                          item.key ===
                                          _ctx.OrderTrackingOrderProgressionKey.OrderAssign
                                        )
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                class: "text-muted",
                                                innerHTML: 
                                            _ctx.t(
                                              'salesOrderOverview.orderProgressionAssigned',
                                              [
                                                _ctx.customFormatDateTime(
                                                  row.date,
                                                  'MM.DD, HH:mm'
                                                ),
                                                ...row.completion,
                                              ]
                                            )
                                          
                                              }, null, 8, _hoisted_114))
                                            : (
                                          item.key ===
                                          _ctx.OrderTrackingOrderProgressionKey.OrderApproved
                                        )
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 1,
                                                  class: "text-muted",
                                                  innerHTML: 
                                            _ctx.t(
                                              'salesOrderOverview.orderProgressionApproved',
                                              [
                                                _ctx.customFormatDateTime(
                                                  row.date,
                                                  'MM.DD, HH:mm'
                                                ),
                                                ...row.completion,
                                              ]
                                            )
                                          
                                                }, null, 8, _hoisted_115))
                                              : (
                                          item.key ===
                                          _ctx.OrderTrackingOrderProgressionKey.OrderShipped
                                        )
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 2,
                                                    class: "text-muted",
                                                    innerHTML: 
                                            _ctx.t(
                                              'salesOrderOverview.orderProgressionShipped',
                                              [
                                                _ctx.customFormatDateTime(
                                                  row.date,
                                                  'MM.DD, HH:mm'
                                                ),
                                                ...row.completion,
                                              ]
                                            )
                                          
                                                  }, null, 8, _hoisted_116))
                                                : (
                                          item.key ===
                                          _ctx.OrderTrackingOrderProgressionKey.ArticleReview
                                        )
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 3,
                                                      class: "text-muted",
                                                      innerHTML: 
                                            _ctx.t(
                                              'salesOrderOverview.orderProgressionArticleReview',
                                              [
                                                _ctx.customFormatDateTime(
                                                  row.date,
                                                  'MM.DD, HH:mm'
                                                ),
                                                ...row.completion,
                                              ]
                                            )
                                          
                                                    }, null, 8, _hoisted_117))
                                                  : (
                                          item.key ===
                                          _ctx.OrderTrackingOrderProgressionKey.ArticleShipped
                                        )
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 4,
                                                        class: "text-muted",
                                                        innerHTML: 
                                            _ctx.t(
                                              'salesOrderOverview.orderProgressionArticleShippedItem',
                                              [
                                                _ctx.customFormatDateTime(
                                                  row.date,
                                                  'MM.DD, HH:mm'
                                                ),
                                                ...row.completion,
                                              ]
                                            )
                                          
                                                      }, null, 8, _hoisted_118))
                                                    : (
                                          item.key ===
                                          _ctx.OrderTrackingOrderProgressionKey.ArticleDelivered
                                        )
                                                      ? (_openBlock(), _createElementBlock("div", {
                                                          key: 5,
                                                          class: "text-muted",
                                                          innerHTML: 
                                            _ctx.t(
                                              'salesOrderOverview.orderProgressionDelivered',
                                              [
                                                _ctx.customFormatDateTime(
                                                  row.date,
                                                  'MM.DD, HH:mm'
                                                ),
                                                ,
                                                ...row.completion,
                                              ]
                                            )
                                          
                                                        }, null, 8, _hoisted_119))
                                                      : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      (row.shipment)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                            _createElementVNode("div", _hoisted_121, [
                                              _createElementVNode("div", _hoisted_122, [
                                                _createElementVNode("span", _hoisted_123, [
                                                  _createVNode(_component_el_image, {
                                                    class: "w-100 h-100",
                                                    fit: "contain",
                                                    title: row.shipment.courier_show,
                                                    src: 
                                                _ctx.getServiceProviderMap(
                                                  row.shipment.courier
                                                )
                                              
                                                  }, null, 8, ["title", "src"])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_124, [
                                                _createElementVNode("div", _hoisted_125, [
                                                  _createElementVNode("div", _hoisted_126, [
                                                    _createElementVNode("span", _hoisted_127, [
                                                      _createElementVNode("span", null, _toDisplayString(_ctx.t(
                                                      "salesOrderOverview.trackingBatch",
                                                      [row.shipment.package_num]
                                                    )) + " /  ", 1),
                                                      _createElementVNode("span", null, _toDisplayString(row.shipment.courier_show), 1)
                                                    ]),
                                                    _createElementVNode("span", {
                                                      class: _normalizeClass(["badge badge-sm fw-bold ms-2", 
                                                  _ctx.getShipmentStatusMap(
                                                    row.shipment.status
                                                  )
                                                ])
                                                    }, _toDisplayString(row.shipment.status_show), 3)
                                                  ]),
                                                  _createElementVNode("span", _hoisted_128, _toDisplayString(row.shipment.number), 1)
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_129, [
                                              _createElementVNode("div", _hoisted_130, [
                                                _hoisted_131,
                                                _createElementVNode("div", _hoisted_132, [
                                                  _createElementVNode("span", _hoisted_133, [
                                                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen015.svg" })
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_134, [
                                                  _createElementVNode("div", _hoisted_135, [
                                                    _createElementVNode("span", _hoisted_136, _toDisplayString(_ctx.customFormatDate(
                                                  row.shipment.from_date
                                                )), 1),
                                                    _createElementVNode("span", _hoisted_137, _toDisplayString(row.shipment.from_location), 1)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_138, [
                                                _hoisted_139,
                                                _createElementVNode("div", _hoisted_140, [
                                                  _createElementVNode("span", _hoisted_141, [
                                                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen018.svg" })
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_142, [
                                                  _createElementVNode("div", _hoisted_143, [
                                                    _createElementVNode("span", _hoisted_144, _toDisplayString(_ctx.customFormatDate(
                                                    row.shipment.to_date
                                                  )), 1),
                                                    _createElementVNode("span", _hoisted_145, _toDisplayString(row.shipment.to_location), 1)
                                                  ])
                                                ])
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]),
                                (item.sku_list.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sku_list, (row, rowIndex) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "d-flex align-items-center border border-dashed border-gray-300 rounded px-3 py-7",
                                          key: rowIndex
                                        }, [
                                          _createElementVNode("div", _hoisted_147, [
                                            _createElementVNode("div", _hoisted_148, [
                                              _createElementVNode("span", _hoisted_149, [
                                                (row.product_gallery.length > 0)
                                                  ? (_openBlock(), _createBlock(_component_el_carousel, {
                                                      key: 0,
                                                      class: "w-100",
                                                      "indicator-position": "none",
                                                      autoplay: false,
                                                      arrow: "never",
                                                      height: "50px"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.product_gallery, (gallery, galleryIndex) => {
                                                          return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                                            key: galleryIndex,
                                                            class: "d-flex justify-content-center align-items-center"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_el_image, {
                                                                class: "w-100 h-100 cursor-pointer",
                                                                fit: "contain",
                                                                src: 
                                                gallery.origin_url +
                                                '?x-oss-process=image/resize,l_200'
                                              ,
                                                                onClick: ($event: any) => (
                                                _ctx.previewImages(
                                                  row.product_gallery,
                                                  galleryIndex
                                                )
                                              )
                                                              }, null, 8, ["src", "onClick"])
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        }), 128))
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("span", _hoisted_150, _toDisplayString(row.qty), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_151, [
                                              _createElementVNode("div", _hoisted_152, _toDisplayString(row.article_name), 1),
                                              _createElementVNode("div", _hoisted_153, _toDisplayString(row.article_no), 1),
                                              _createElementVNode("div", {
                                                class: "fs-7 text-nowrap",
                                                innerHTML: 
                                          _ctx.t('order.colorAndSize', [
                                            row.color,
                                            row.size,
                                          ])
                                        
                                              }, null, 8, _hoisted_154)
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ], 8, _hoisted_109)
                        ], 2)
                      ]))
                    }), 128))
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.options.scheduleLoading]
              ])
            ])
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_155, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderTrackingShipmentTracking, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card card-flush",
              key: index
            }, [
              _createElementVNode("div", _hoisted_156, [
                _createElementVNode("div", _hoisted_157, [
                  (!_ctx.options.shipmentScheduleIsVirtual)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrderOverview.shipment")) + " #" + _toDisplayString(index + 1), 1),
                        _createElementVNode("span", _hoisted_158, _toDisplayString(_ctx.t("salesOrderOverview.trackingBatches", [
                    _ctx.orderTrackingShipmentTracking.length,
                  ])), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrderOverview.shipmentSchedule")), 1),
                        (!_ctx.isAuditView)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_159, _toDisplayString(item.info.mb_fulfillment_type), 1))
                          : _createCommentVNode("", true)
                      ], 64))
                ]),
                (!_ctx.options.shipmentScheduleIsVirtual && !_ctx.isAuditView)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.changeShipmentShow(item)),
                        type: "button",
                        class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                      }, [
                        _createElementVNode("span", _hoisted_162, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen024.svg" })
                        ])
                      ], 8, _hoisted_161)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_163, [
                (!_ctx.options.shipmentScheduleIsVirtual)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_164, [
                        _createElementVNode("div", _hoisted_165, [
                          _createElementVNode("span", _hoisted_166, [
                            (_ctx.getServiceProviderMap(item.info.courier))
                              ? (_openBlock(), _createBlock(_component_el_image, {
                                  key: 0,
                                  class: "d-flex",
                                  fit: "contain",
                                  title: item.info.courier_show,
                                  src: _ctx.getServiceProviderMap(item.info.courier)
                                }, null, 8, ["title", "src"]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_167, [
                          _createElementVNode("div", _hoisted_168, [
                            _createElementVNode("div", _hoisted_169, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.t("salesOrderOverview.trackingBatch", [1])) + " / ", 1),
                              _createElementVNode("span", null, _toDisplayString(item.info.courier_show), 1)
                            ]),
                            _createElementVNode("div", _hoisted_170, " #" + _toDisplayString(item.info.number), 1)
                          ]),
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge badge-lg fw-bold my-2", _ctx.getShipmentStatusMap(item.info.status)])
                          }, _toDisplayString(item.info.status_show), 3)
                        ])
                      ]),
                      (!_ctx.isAuditView)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_171, [
                            _hoisted_172,
                            _createElementVNode("div", _hoisted_173, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sku_list, (row, rowIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "fw-bold active symbol p-0",
                                  key: rowIndex
                                }, [
                                  _createElementVNode("span", _hoisted_174, [
                                    (row.product_gallery.length > 0)
                                      ? (_openBlock(), _createBlock(_component_el_carousel, {
                                          key: 0,
                                          class: "w-100",
                                          "indicator-position": "none",
                                          autoplay: false,
                                          arrow: "never",
                                          height: "50px"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.product_gallery, (gallery, galleryIndex) => {
                                              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                                                key: galleryIndex,
                                                class: "d-flex justify-content-center align-items-center"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_image, {
                                                    class: "w-100 h-100 cursor-pointer",
                                                    fit: "contain",
                                                    title: _ctx.t('order.size') + ': ' + row.size,
                                                    src: 
                              gallery.origin_url +
                              '?x-oss-process=image/resize,l_200'
                            ,
                                                    onClick: ($event: any) => (
                              _ctx.previewImages(row.product_gallery, galleryIndex)
                            )
                                                  }, null, 8, ["title", "src", "onClick"])
                                                ]),
                                                _: 2
                                              }, 1024))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("span", _hoisted_175, _toDisplayString(row.qty), 1)
                                ]))
                              }), 128))
                            ]),
                            _hoisted_176,
                            _createElementVNode("div", _hoisted_177, [
                              _createElementVNode("div", _hoisted_178, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tracking, (row, rowIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "timeline-item align-items-center mb-4",
                                    key: rowIndex
                                  }, [
                                    (rowIndex !== item.tracking.length - 1)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _hoisted_179,
                                          _createElementVNode("div", _hoisted_180, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["svg-icon svg-icon-2", {
                              'svg-icon-danger': row.crossed === 1,
                            }])
                                            }, [
                                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen015.svg" })
                                            ], 2)
                                          ])
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _hoisted_181,
                                          _createElementVNode("div", _hoisted_182, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["svg-icon svg-icon-2", {
                              'svg-icon-info': row.crossed === 1,
                            }])
                                            }, [
                                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen018.svg" })
                                            ], 2)
                                          ])
                                        ], 64)),
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["timeline-content m-0", {
                          'opacity-50': row.crossed === 0,
                        }])
                                    }, [
                                      _createElementVNode("span", _hoisted_183, _toDisplayString(_ctx.customFormatDateTime(row.date)), 1),
                                      (
                            row.key ===
                            _ctx.OrderTrackingShipmentTrackingKey.Delivery
                          )
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_184, _toDisplayString(_ctx.t(
                                "salesOrderOverview.orderShipmentTrackingFromWarehouse",
                                [item.info.from_location]
                              )), 1))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("span", _hoisted_185, _toDisplayString(_ctx.getOrderTrackingShipmentTrackingKeyMap(row.key, _ctx.t)), 1),
                                      (
                            row.key ===
                            _ctx.OrderTrackingShipmentTrackingKey.Delivered
                          )
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(row.items, (it, itIndex) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              class: "d-block fw-semibold text-gray-400",
                                              key: itIndex
                                            }, [
                                              _createElementVNode("span", {
                                                innerHTML: 
                                _ctx.t(
                                  'salesOrderOverview.orderShipmentTrackingNo',
                                  [
                                    _ctx.customFormatDate(it.date, 'MM.DD, HH:mm'),
                                    it.tracking_no,
                                    item.info.courier_show,
                                  ]
                                )
                              
                                              }, null, 8, _hoisted_186)
                                            ]))
                                          }), 128))
                                        : _createCommentVNode("", true)
                                    ], 2)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ], 512)), [
                            [_vShow, item.isShow]
                          ])
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (index != 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_187))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_188, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tracking, (row, rowIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "timeline-item",
                            key: rowIndex
                          }, [
                            _createElementVNode("div", _hoisted_189, _toDisplayString(_ctx.customFormatDate(row.date, "MM.DD")), 1),
                            _hoisted_190,
                            _createElementVNode("div", _hoisted_191, [
                              _createElementVNode("span", _hoisted_192, _toDisplayString(_ctx.getOrderTrackingShipmentTrackingKeyMap(row.key, _ctx.t)), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.items, (it, itIndex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: itIndex,
                                  class: "d-flex flex-column fs-6"
                                }, [
                                  _createElementVNode("div", _hoisted_193, [
                                    _createElementVNode("div", _hoisted_194, _toDisplayString(it), 1)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        }), 128))
                      ])
                    ], 64))
              ])
            ]))
          }), 128))
        ])), [
          [_directive_loading, _ctx.options.shipmentLoading]
        ])
      ])
    ]),
    _createVNode(_component_FsLightbox, {
      toggler: _ctx.options.toggler,
      sources: _ctx.options.sources,
      slide: _ctx.options.sourcesSlide
    }, null, 8, ["toggler", "sources", "slide"])
  ], 64))
}